import { useCallback, useEffect, useState } from 'react';
import { propertiesApi } from './properties-api';
import { API_MODE, PROPERTIES_API_ERROR_MESSAGES } from './constants';

export const usePropertiesList = ({
  loadingMode,
  setLoadingMode,
  setErrorMessage,
}) => {
  const [properties, setProperties] = useState();
  const [selectedPropertyId, setSelectedPropertyId] = useState();

  const shouldFetchProperties = !properties && loadingMode === null;

  const fetchPropertiesList = useCallback(async () => {
    setLoadingMode(API_MODE.PROPERTY_LIST);
    try {
      const properties = await propertiesApi.getPropertyList();

      const [{ id: initialSelectedPropertyId } = {}] = properties;
      setSelectedPropertyId(initialSelectedPropertyId);

      setProperties(properties);

      if (properties.length === 0) {
        setLoadingMode(null);
      }
    } catch {
      setProperties([]);
      setErrorMessage({
        [API_MODE.PROPERTY_LIST]:
          PROPERTIES_API_ERROR_MESSAGES.GET_PROPERTY_LIST,
      });
      setLoadingMode(null);
    }
  }, [setErrorMessage, setLoadingMode]);

  useEffect(() => {
    if (shouldFetchProperties) {
      fetchPropertiesList();
    }
  }, [fetchPropertiesList, shouldFetchProperties]);

  return {
    fetchPropertiesList,
    propertiesList: properties || [],
    selectedPropertyId,
    setSelectedPropertyId,
  };
};
